import { render } from "./Khutba.vue?vue&type=template&id=1ca86624&scoped=true"
import script from "./Khutba.vue?vue&type=script&lang=js"
export * from "./Khutba.vue?vue&type=script&lang=js"

import "./Khutba.vue?vue&type=style&index=0&id=1ca86624&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca86624"]])

export default __exports__